import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.page.html',
  styleUrls: ['./subscribe.page.scss'],
})
export class SubscribePage implements OnInit {

  subscribeSuccess: string = null;
  headerBranding: String;


  errorMessages = {
    email: [
      { type: 'required', message: 'Email address required' },
      { type: 'email', message: 'Please enter a valid email address'}
    ]
  }

   emailForm = this.formBuilder.group({
            email: ['', [Validators.required,Validators.email]]
    })


    constructor(private formBuilder: FormBuilder, public httpClient: HttpClient,
      private configService: ConfigService) { }

    goToSubscribe = async () => {
        let subscribeEmail = this.emailForm.value.email;
        let response =  await fetch(`https://ballotpedia.org/whatcounts_subscribe.php?email=${subscribeEmail}`,
         {
           method: 'GET',
           headers: {}
         })
         this.emailForm.reset();
         this.subscribeSuccess = 'Thank you for subscribing to Ballotpedia Email Updates.';
       }

      get email() {
        return this.emailForm.get('email');
     }

  async ngOnInit() {
    let res = await this.configService.getConfiguration();
    this.headerBranding = res["headerBranding"];
  }

}
